export default "__VITE_ASSET__CUYUyFwe__"